import { clientPublic } from 'helper/axios'
import { handleError } from 'helper/rest'
import { get } from 'lodash'

export const addDependencies = async (params, token) => {
  try {
    return await clientPublic
      .post(
        `sprintflow/depend`,
        params,

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const searchDependencies = async (params, token) => {
  try {
    return await clientPublic
      .post(`sprintflow/depend/search`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getDependenciesList = async (project_id, sprintflow_id, token) => {
  try {
    return await clientPublic
      .get(`sprintflow/depend?project_id=${project_id}&sprintflow_id=${sprintflow_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const deleteDependencies = async (params, token) => {
  try {
    return await clientPublic
      .delete(`sprintflow/depend`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: params,
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
